import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  confirmText = 'Yes',
  cancelText = 'No',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: (theme) => theme.custom.background2,
          borderRadius: '20px',
          padding: '24px',
        },
      }}
    >
      <DialogTitle>
        <Typography
          sx={{
            color: (theme) => theme.custom.text,
            fontSize: '18px',
            fontWeight: 500,
            fontFamily: 'Manrope',
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogActions sx={{ padding: '24px 24px 0' }}>
        <Button
          onClick={onClose}
          sx={{
            borderRadius: 16,
            backgroundColor: '#E35050',
            color: '#fff',
            fontWeight: 700,
            '&:hover': {
              backgroundColor: '#E35050',
              opacity: 0.9,
            },
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          sx={{
            borderRadius: 16,
            backgroundColor: 'var(--fi-button, #FF6A00)',
            marginLeft: '20px',
            color: 'var(--fi-button-text, #fff)',
            fontWeight: 700,
            '&:hover': {
              backgroundColor: 'var(--fi-button, #FF6A00)',
              opacity: 0.9,
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
